import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getJobs() {
  try {
    return await apiFetch<any[]>('/api/jobs');
  } catch {
    return [];
  }
}

export async function getJobById(id: string) {
  try {
    return await apiFetch<any>(`/api/jobs/${id}`);
  } catch {
    return null;
  }
}

export async function getJobBySlug(slug: string) {
  try {
    return await apiFetch<any>(`/api/public/jobs/slug/${encodeURIComponent(slug)}`);
  } catch {
    return null;
  }
}

export async function getJobsList() {
  try {
    return await apiFetch<any[]>('/api/public/jobs/list');
  } catch {
    return [];
  }
}

export async function createJob(data: any) {
  return apiPost('/api/jobs', data);
}

export async function updateJob(id: string, data: any) {
  return apiPut(`/api/jobs/${id}`, data);
}

export async function deleteJob(id: string) {
  return apiDelete(`/api/jobs/${id}`);
}
